export default {"src":"/blogs/_next/static/media/cgcLogo.bc41edc7.svg","height":65,"width":193,"blurWidth":0,"blurHeight":0};